export function getBorrowingSummaries(apiClient, params) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/borrowing/summaries`;
  return apiClient.get(route, { query: params });
}

export default {
  getBorrowingSummaries
};



// WEBPACK FOOTER //
// ./app/api/BorrowingApi.js